import { selectAccount } from "~/domains/user/api/SetAccount";

export interface PreviousAccountRollback {
  accountId: string;
  salesOrg: string;
  redirectUrl: string;
}

export async function restorePreviousAccount(
  previousAccount: PreviousAccountRollback,
  navigate: (url: string) => void = (url) => window.location.assign(url),
): Promise<void> {
  await selectAccount({
    accountId: previousAccount.accountId,
    salesOrg: previousAccount.salesOrg,
  });
  navigate(previousAccount.redirectUrl);
}
